import { Button, Card, Form } from "@themesberg/react-bootstrap";
import React, { useEffect, useState, useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import SearchInput from "../../../components/SearchInput";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../../routes";
import { fetchApi, postApi } from "../../../redux/api";
import { formatNumber } from "../../../redux/utils";
import { Modal, Table } from "reactstrap";

const PVPaymentSchedule = () => {
  const [filterText, setFilterText] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [pvList, setPvList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  const mda = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const toggleModal = () => setOpenModal(!openModal);

  useEffect(() => {
    if (mda?.mda_name && mda?.mda_code) {
      setLoading(true);
      fetchApi(
        `get_new_pv_by_mda?query_type=get_ag_upload_pv&mda_name=${mda.mda_name}&mda_code=${mda.mda_code}`
      )
        .then((data) => setPvList(data.result || []))
        .catch((error) => console.error("Error fetching data:", error))
        .finally(() => setLoading(false));
    }
  }, [mda]);

  const handleCheckboxChange = (pv_code) => {
    setSelectedRows((prev) =>
      prev.includes(pv_code)
        ? prev.filter((item) => item !== pv_code)
        : [...prev, pv_code]
    );
  };

  const handleSelectAll = () => {
    const selectableIds = pvList
      .filter((item) => item.status !== "Pending") // Exclude "Pending" items
      .map((item) => item.pv_code);

    setSelectedRows(
      selectedRows.length === selectableIds.length ? [] : selectableIds
    );
  };

  const handleGenerateSchedules = () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one row to generate schedules.");
      return;
    }

    const selectedPvCodes = pvList
      .filter((item) => selectedRows.includes(item.pv_code))
      .map((item) => item.pv_code);

    setLoading(true);

    postApi("update_status/payment_schedule/by/pv_code", {
      status: "payment_schedule_request",
      pv_codes: selectedPvCodes,
    })
      .then(() => {
        setSelectedRows([]);
        setOpenModal(true);
        alert("Schedules generated successfully!");
        return fetchApi(
          `get_new_pv_by_mda?query_type=get_ag_upload_pv&mda_name=${mda.mda_name}&mda_code=${mda.mda_code}`
        );
      })
      .then((data) => setPvList(data.result || []))
      .catch((error) => {
        console.error("Error generating schedules:", error);
        alert("Failed to generate schedules. Please try again.");
      })
      .finally(() => setLoading(false));
  };

  const totalAmount = pvList
    .filter((item) => selectedRows.includes(item.pv_code))
    .reduce((sum, item) => sum + (Number(item.amount) || 0), 0);

  const filteredPvList = useCallback(() => {
    return pvList.filter((item) =>
      item.mda_name.toLowerCase().includes(filterText.toLowerCase())
    );
  }, [filterText, pvList])();

  return (
    <div>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <h4>PV List</h4>
        <Button
          variant="success"
          disabled={selectedRows.length === 0}
          onClick={handleGenerateSchedules}
        >
          {loading ? "Processing..." : "Request for Payment Schedules"}
        </Button>
      </div>

      <Row>
        <Col md={6}>
          Total PVs Selected: <b>{selectedRows.length}</b>
        </Col>
        <Col md={6}>
          Total Amount: <b>{formatNumber(totalAmount)}</b>
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col md={6} style={{ marginTop: 28 }}>
          <SearchInput
            placeholder="Search For PVs"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </Col>
        <Col md={6}>
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Date From</Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Date To</Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>

      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body
          className="p-0"
          style={{ height: "80vh", overflow: "scroll" }}
        >
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : filteredPvList.length > 0 ? (
            <Table hover bordered>
              <thead
                className="table-header"
                style={{ backgroundColor: "green" }}
              >
                <tr>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    <Form.Check
                      type="checkbox"
                      onChange={handleSelectAll}
                      checked={
                        pvList.filter((item) => item.status !== "Pending")
                          .length > 0 &&
                        selectedRows.length ===
                          pvList.filter((item) => item.status !== "Pending")
                            .length
                      }
                    />
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Action
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    MDA Name
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    MDA Code
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Economic Code
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Economic Description
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Fund Code
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Fund Description
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Status
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Amount Payable
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredPvList.map((item) => (
                  <tr key={item.pv_code}>
                    <td>
                      {item.status !== "Pv Release" && (
                        <Form.Check
                          type="checkbox"
                          onChange={() => handleCheckboxChange(item.pv_code)}
                          checked={selectedRows.includes(item.pv_code)}
                        />
                      )}
                    </td>
                    <td>
                      <Button
                        onClick={() =>
                          navigate(
                            `${Routes.pv.agPvCheckIndex}/${item.pv_code}`
                          )
                        }
                      >
                        View
                      </Button>
                    </td>
                    <td>{item.mda_name}</td>
                    <td>{item.mda_code}</td>
                    <td>{item.economic_code}</td>
                    <td>{item.description_code}</td>
                    <td>{item.fund_code}</td>
                    <td>{item.fund_description}</td>
                    <td>{item.status}</td>
                    <td style={{ textAlign: "right" }}>
                      {formatNumber(item.amount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="text-center py-4">No records found.</div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PVPaymentSchedule;
